<div class="tags" *ngIf="queryTags?.length > 0">
  <div *ngFor="let tag of queryTags">
    <span> {{ tag.key | textHumanize }}: {{ tag.type === 'date' ? (tag.value | date: 'shortDate') : tag.value }} </span>
    <span class="close" (click)="removeFilter(tag)">
      <i class="icon">close</i>
    </span>
  </div>
</div>
